function extra(){
    // console.log('%c ',`
    // font-size : 320px;
    // padding-left: 150px;
    // background-image:url("https://web-resource.17m3.com/m3guo/202109/adshop/images/view-bottom.png");
    // background-size : 303px 225px;
    // background-repeat : no-repeat;
    // background-position : left center;`)

    console.log('%c家人们，别捣鼓控制台了，知道今天是什么日子吗？ 今天是阿斗赶集，征战印记100个只需99币！',`
    font-size : 40px;
    color : #683d1e;
    font-weight : 700;
    `)
}

export default { extra }


// WEBPACK FOOTER //
// ./src/assets/js/misc.js